/* eslint-disable max-len */
import { Box, Grid, Menu, MenuItem, Stack, Typography, useMediaQuery } from '@mui/material';
import React, { memo, useContext, useState } from 'react';
import { IoMdMore } from 'react-icons/io';
import CreationFieldPopUp from './CreationPopup';
import { useNavigate } from 'react-router-dom';
import { LanguageContext } from '../../../../../libs/Context';
import { Theme } from '@mui/material/styles';
import useFeedApproval from './CustomHooks/useFeedApproval';

const FeedCreation = (props) =>
{
	const { setSelectedFilter } = props;
	const { language } = useContext(LanguageContext);
	const [ CreationPopupOpen, setCreationPopupOpen ] = useState(false);
	const [ anchorEl, setAnchorEl ] = React.useState<null | HTMLElement>(null);
	const open = Boolean(anchorEl);
	const navigate = useNavigate();
	const isMobileSM = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));
	const isMobileLg = useMediaQuery((theme: Theme) => theme.breakpoints.down('lg'));
	const { isFeedsAdmin } = useFeedApproval();
	const handleClick = (event) =>
	{
		setAnchorEl(event.currentTarget);
	};
	const handleClose = () =>
	{
		setAnchorEl(null);
	};
	const handleOpenCreation = () =>
	{
		setCreationPopupOpen(true);
	};
	const handleUpdateFilter = () =>
	{
		setSelectedFilter((prevFilter) => (Object.keys(prevFilter)?.length ? {} : prevFilter));
	};

	return (
		<Grid item pt={2} pb={1.5} position='sticky' top={isMobileSM ? 108 : isMobileLg ? 119 : 126} sx={{ zIndex: 99, backgroundColor: 'var(--baseColor)' }}>
			<Grid item width='var(--percent100)'>
				<Grid container flexDirection={'row'} alignItems={'center'} sx={{ backgroundColor: 'var(--whiteColor)' }} p='var(--pixel16)' borderRadius={'13px'}>
					<Grid item xs sx={{ backgroundColor: '#57575712', cursor: 'pointer' }} onClick={handleOpenCreation} borderRadius={'var(--pixel8)'} px='var(--pixel16)' py='var(--pixel12)'>
						<Stack direction='row' justifyContent={'space-between'} alignItems={'center'} width={'var(--percent100)'}>
							<Typography fontWeight='var(--font500)'>{language.whatsonyourmind}</Typography>
							<Box width={'var(--pixel24)'} height={'var(--pixel24)'}>
								<img src='/images/icons/FeedfileIcon.svg' alt='' style={{ width: 'var(--percent100)', height: 'var(--percent100)' }}/>
							</Box>
						</Stack>
					</Grid>
					<Grid item pl='var(--pixel8)'>
						<IoMdMore fontSize={'26px'} onClick={handleClick} style={{ cursor: 'pointer' }}/>
					</Grid>
					<Menu
						id='basic-menu'
						anchorEl={anchorEl}
						open={open}
						onClose={handleClose}
						MenuListProps={{
							'aria-labelledby' : 'basic-button'
						}}
					>
						<MenuItem onClick={() => { navigate('/news/myactivity'); handleUpdateFilter(); }}>{language?.myActivity}</MenuItem>
						{isMobileSM && <MenuItem onClick={() => { navigate('/news/bookmarks'); handleUpdateFilter(); }}>{language?.bookmark}</MenuItem>}
						{isMobileSM && <MenuItem onClick={() => { navigate('/news/celebrationevents'); handleUpdateFilter(); }}>{language?.events}</MenuItem>}
						{isMobileSM && <MenuItem onClick={() => { navigate('/news/popularfeeds'); handleUpdateFilter(); }}>{language?.PopularFeeds}</MenuItem>}
						<MenuItem onClick={() => { navigate('/news/draft'); handleUpdateFilter(); }}>{language?.drafts}</MenuItem>
						{isFeedsAdmin && (
							<MenuItem
								onClick={() =>
								{
									navigate('/news/pendingapproval');
									handleUpdateFilter();
								}}
							>
								{language?.feedsForApproval || 'Feeds for Approval'}
							</MenuItem>
						)}
					</Menu>
					{CreationPopupOpen && <CreationFieldPopUp OpenPop={CreationPopupOpen} handleClosePop={() => setCreationPopupOpen(false)}/>}
				</Grid>
			</Grid>
		</Grid>

	);
};

export default memo(FeedCreation);